"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_router_dom_1 = require("react-router-dom");
var react_redux_1 = require("react-redux");
var PlacesAutocomplete_1 = __importDefault(require("../PlacesAutocomplete/PlacesAutocomplete"));
var api_1 = require("@react-google-maps/api");
var GoogleGeocoding_1 = __importDefault(require("../../constants/GoogleGeocoding"));
var searchParamsSlice_1 = require("../../features/searchParams/searchParamsSlice");
var filters_1 = require("../../helpers/filters");
var i18n_1 = __importDefault(require("../../i18n"));
var react_i18next_1 = require("react-i18next");
var languageSlice_1 = require("../../features/languages/languageSlice");
var Localization_1 = require("../../constants/Localization");
var BannerNavigation_1 = require("../../constants/BannerNavigation");
var currencySlice_1 = require("../../features/currencies/currencySlice");
var search_icon_hy_svg_1 = __importDefault(require("../../../images/search_icon_hy.svg"));
var search_icon_ru_svg_1 = __importDefault(require("../../../images/search_icon_ru.svg"));
var classnames_1 = __importDefault(require("classnames"));
var BannerSection = function () {
    var history = react_router_dom_1.useHistory();
    var isLoaded = api_1.useJsApiLoader({
        googleMapsApiKey: GoogleGeocoding_1.default.API_KEY,
        libraries: GoogleGeocoding_1.default.MAP_LIBS,
        language: i18n_1.default.language,
    }).isLoaded;
    var currentLanguage = react_redux_1.useSelector(languageSlice_1.selectCurrentLanguage);
    var t = react_i18next_1.useTranslation('common').t;
    var dispatch = react_redux_1.useDispatch();
    var currency = react_redux_1.useSelector(currencySlice_1.selectCurrentCurrency);
    var handleSearchResult = function (place) {
        if (place) {
            dispatch(searchParamsSlice_1.setViewBox({ viewBox: place.geometry }));
            var geometry = place.geometry, main_text = place.main_text;
            var queryUrl = filters_1.createQueryUrl({
                viewBox: geometry,
                address: __assign(__assign({}, filters_1.extractStateDistrictFromPlace(place)), { placeName: main_text }),
            });
            history.push("/" + Localization_1.SellPagePrefix[i18n_1.default.language].sell + "?" + queryUrl);
        }
    };
    return (react_1.default.createElement("div", { className: classnames_1.default('home-banner', 'lang-' + currentLanguage) },
        react_1.default.createElement("div", { className: "banner-content" },
            react_1.default.createElement("section", { className: "banner-icons" }, BannerNavigation_1.BANNER_NAVIGATION.map(function (navItem) {
                var icon = navItem.icon, text = navItem.text, page = navItem.page, uri = navItem.uri;
                return (react_1.default.createElement("div", { key: text, className: "banner-icon-container" },
                    react_1.default.createElement(react_router_dom_1.Link, { className: "banner-link", to: "/" + Localization_1.SellPagePrefix[i18n_1.default.language][page] + "?" + uri[currency] },
                        react_1.default.createElement("div", { className: "banner-link-content" },
                            react_1.default.createElement("img", { src: icon, className: "banner-icon-image", alt: t(text) }),
                            react_1.default.createElement("p", { className: "banner-icon-text" }, t(text))))));
            })),
            react_1.default.createElement("section", { className: "banner-text-container" },
                react_1.default.createElement("h3", { className: "banner-text" },
                    react_1.default.createElement("span", { className: "banner-text-left" }, t('BANNER_SECTION.TITLE_LEFT')),
                    react_1.default.createElement("img", { src: currentLanguage === Localization_1.Language.hy
                            ? search_icon_hy_svg_1.default
                            : search_icon_ru_svg_1.default, className: "banner-text-icon", alt: "search" }),
                    react_1.default.createElement("span", { className: "banner-text-right" }, t('BANNER_SECTION.TITLE_RIGHT')))),
            react_1.default.createElement("div", { className: "search-input-wrapper" }, isLoaded && (react_1.default.createElement(PlacesAutocomplete_1.default, { onSelect: handleSearchResult }))))));
};
exports.default = BannerSection;
